import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-materialize/lib/Button';
import { Row, Col } from 'react-materialize';
import { FormattedMessage } from 'react-intl';

import '../static/MobileRedirect.css';
import Logger from '../functions/logging';
import DeviceHelper from '../functions/device';

class MobileRedirect extends Component {
	componentDidMount() {
		if (!DeviceHelper.isMobile) this.goToLandingPage();
	}

	redirectMobile = () => {
		if (this.props.targetParams && this.props.targetParams.url) {
			// We want to deeplink into the app
			const redirectUrl = "https://pilotly.app.link/partner" + this.props.targetParams.url;
			Logger.log(this.constructor.name, "redirectMobile() deep link", redirectUrl, this.props.targetParams);
			window.location = redirectUrl; 
		}
		else if (DeviceHelper.isIOS) {
			Logger.log(this.constructor.name, "redirectMobile() iOS");
			window.location = "itms://itunes.apple.com/us/app/pilotly/id1044960605?mt=8";
		} else if (DeviceHelper.isAndroid) {
			Logger.log(this.constructor.name, "redirectMobile() android");
			window.location = "https://play.google.com/store/apps/details?id=com.pilotly";
		}
		else {
			Logger.log(this.constructor.name, "redirectMobile() default");
		}
	}

	goToLandingPage = () => {
		this.props.history.push('/');
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.props.location);

		const webOnly = true;
		if (webOnly) {
			return (
				<div className='mobile-redirect-container'>
					<Row>
						<Col s={12}>
							<div className='mobile-redirect-text-container'>
								<h1>
									<FormattedMessage
										id="mobile_redirect.title"
										defaultMessage={"Mobile Device Detected"}
									/>
								</h1>
								<p>
									This study cannot be taken on a mobile device. Please try the link again on your laptop or other desktop device.
								</p>
							</div>
						</Col>
					</Row>
				</div>
			);
		}

		return (
			<div className='mobile-redirect-container'>
				<Row>
					<Col s={12}>
						<div className='mobile-redirect-text-container'>
							<h1>
								<FormattedMessage
									id="mobile_redirect.title"
									defaultMessage={"Mobile Device Detected"}
								/>
							</h1>
							<p>
								<FormattedMessage
									id="mobile_redirect.body"
									defaultMessage={"Would you like to see Pilotly in the app?"}
								/>
							</p>
						</div>
					</Col>

					<Col s={12}>
						<div className='mobile-redirect-btns-container'>
							<Button className='mobile-redirect-btns red' onClick={this.goToLandingPage}>
								<FormattedMessage
									id="mobile_redirect.button.no"
									defaultMessage={"No"}
								/>
							</Button>
							<Button className='mobile-redirect-btns' onClick={this.redirectMobile}>
								<FormattedMessage
									id="mobile_redirect.button.yes"
									defaultMessage={"Yes"}
								/>
							</Button>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		targetParams: state.targetProcess.targetParams,
	};
}

export default connect(mapStateToProps)(MobileRedirect);



// WEBPACK FOOTER //
// ./src/pages/MobileRedirect.js